define('AA.OutOfStock.StockCheck.Model', [
    'Utils',
    'jQuery'
], function(Utils, jQuery) {
    'use strict';

    return {
        getServiceUrl: function getServiceUrl() {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath('services/StockCheck.Service.ss')
            );
        },

        checkStock: function checkStock(itemIds) {
            if (!itemIds || !itemIds.length) {
                var deferred = jQuery.Deferred();
                deferred.resolve({ items: [] });
                return deferred.promise();
            }

            return jQuery.get(this.getServiceUrl(), {
                itemIds: itemIds.join(',')
            });
        }
    };
});
